export const termsHtml = `
<h2>Terms of Service</h2>
<p><em>Last updated: October 6, 2026</em></p>

<h3>1. Acceptance of Terms</h3>
<p>By accessing or using Boostly ("the Service"), you agree to be bound by these Terms of Service. If you do not agree, do not use the Service.</p>

<h3>2. Description of Service</h3>
<p>Boostly is a social engagement platform that allows users to purchase and receive engagement services (such as followers, likes, views, and comments) across supported social media platforms, including Telegram, Instagram, X (Twitter), and LinkedIn. Users earn and spend in-app coins as the medium of exchange.</p>

<h3>3. Eligibility</h3>
<p>You must be at least 16 years of age to use the Service. By using the Service, you represent and warrant that you meet this age requirement.</p>

<h3>4. Account Registration</h3>
<p>You may register using email, Google, Facebook, X, or Telegram authentication. You are responsible for maintaining the confidentiality of your account and for all activities under it.</p>

<h3>5. Coins and Purchases</h3>
<ul>
  <li>Coins are in-app credits used to purchase engagement services.</li>
  <li>Coins can be earned through referrals, promotions, or purchased via supported payment methods.</li>
  <li>Coins have no real-world monetary value and are non-transferable outside the Service.</li>
  <li>All purchases are final and non-refundable unless required by applicable law.</li>
</ul>

<h3>6. User Conduct</h3>
<p>You agree not to:</p>
<ul>
  <li>Use the Service for any unlawful purpose.</li>
  <li>Attempt to manipulate or abuse the engagement system.</li>
  <li>Use automated tools, bots, or scripts to interact with the Service.</li>
  <li>Impersonate any person or entity.</li>
  <li>Interfere with or disrupt the Service or its servers.</li>
</ul>

<h3>7. Third-Party Platforms</h3>
<p>The Service interacts with third-party social media platforms. Your use of those platforms is governed by their respective terms. We are not responsible for actions taken by third-party platforms against your accounts.</p>

<h3>8. Intellectual Property</h3>
<p>All content, branding, and software associated with the Service are owned by or licensed to Boostly. You may not copy, modify, or distribute any part of the Service without prior written consent.</p>

<h3>9. Copyright and Trademark Complaints</h3>
<p>Names, logos, and trademarks of third-party platforms (such as Instagram, TikTok, YouTube, Telegram, X, Facebook, Twitch, and Spotify) belong to their respective owners. Boostly uses them only to describe which platforms the Service supports, and is not affiliated with, endorsed by, or sponsored by those companies.</p>
<p>If you believe that content in the Service infringes your copyright or trademark, email support@boostly.chainlabsdev.com with the subject "Copyright complaint" and include: your name and contact details; a description of the work or mark you own; where the material appears in the Service; a statement that you believe in good faith the use is not authorized; and a statement that the information you provide is accurate and that you are the owner or authorized to act for the owner. We review complaints and reply by email, may remove or disable the material, and may terminate the accounts of repeat infringers.</p>

<h3>10. Termination</h3>
<p>We reserve the right to suspend or terminate your account at our discretion, including for violations of these Terms. Upon termination, your access to the Service and any remaining coins will be forfeited.</p>

<h3>11. Disclaimer of Warranties</h3>
<p>The Service is provided "as is" and "as available" without warranties of any kind, whether express or implied. We do not guarantee uninterrupted or error-free operation.</p>

<h3>12. Limitation of Liability</h3>
<p>To the maximum extent permitted by law, Boostly shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of the Service.</p>

<h3>13. Changes to These Terms</h3>
<p>We may update these Terms from time to time. Continued use of the Service after changes constitutes acceptance of the new Terms. We will notify you of material changes through the Service.</p>

<h3>14. Contact</h3>
<p>For questions about these Terms, contact us at support@boostly.chainlabsdev.com.</p>
`.trim();
